import { type Theme, alpha } from '@mui/material/styles';

export type StatusRowTone = 'success' | 'warning';

// Left status border plus a faint tint, shared by the per-entity rows under a checklist card.
export function statusRowSx(tone?: StatusRowTone) {
  return {
    bgcolor: (theme: Theme) => (tone ? alpha(theme.palette[tone].light, 0.06) : 'transparent'),
    borderLeft: 4,
    borderLeftColor: tone ? `${tone}.main` : 'transparent',
  };
}
